// extracted by mini-css-extract-plugin
export default {"card":"card_card__T73KE","cardHeader":"card_cardHeader__tEGDP","cardBody":"card_cardBody__QaO4K","amount":"card_amount__T3yp7"};